import ImageGallery from "react-image-gallery";
import { useImageGallery } from "../../hooks/useImageGallery";
import "/node_modules/react-image-gallery/styles/css/image-gallery.css";
import { Card } from "@chakra-ui/react";
import { useParams, Navigate } from "react-router-dom";
import dayjs from "dayjs";
import tz from "dayjs/plugin/timezone";
import advanced from "dayjs/plugin/advancedFormat";
import { FeatureSection } from "../../components/FeatureStyle/FeatureStyle";

dayjs.extend(tz);
dayjs.extend(advanced);

export default function OCVBlogDetail(props: Record<string, any>): JSX.Element {
  const { id } = useParams();
  const { route, blogEntries, manifestData, displayDate, showImage } = props;

  const blogItem = blogEntries.find((obj: any) => {
    return obj?._id?.$id === id;
  });
  const { galleryRef, handleScreenChange, handleFullscreen } =
    useImageGallery();

  const images = blogItem?.images.map((item: Record<string, any>) => {
    return {
      original: item.large,
      originalAlt: blogItem.title,
      originalTitle: "Click to view Fullscreen",
    };
  });

  return !blogItem || !blogItem.title || !blogItem.content ? (
    <Navigate
      to={`/${route}`}
      replace
    />
  ) : (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        minHeight: "400px",
        padding: "1rem 0",
      }}
    >
      {showImage === "top" && blogItem.images.length !== 0 ? (
        <div
          style={{
            maxWidth: "83%",
            paddingTop: "1rem",
            width: "fit-content",
          }}
        >
          <ImageGallery
            items={images}
            showPlayButton={false}
            showFullscreenButton={images.length > 0 ? true : false}
            lazyLoad={true}
            onClick={() => handleFullscreen()}
            onScreenChange={(isFullScreen) => handleScreenChange(isFullScreen)}
            showNav={false}
            showBullets={images.length > 1 ? true : false}
          />
        </div>
      ) : null}

      <Card
        bgColor="white"
        p="1rem"
        minW="2xl"
        maxW="6xl"
        marginY="1rem"
      >
        <h2
          style={{
            fontSize: "2.5rem",
            lineHeight: "2.75rem",
            fontWeight: "bold",
            paddingBottom: "0.75rem",
            textAlign: "center",
          }}
        >
          {blogItem.title}
        </h2>
        {"date" in blogItem && displayDate ? (
          <span style={{ display: "block", margin: "2rem 0" }}>
            <strong>
              Posted on{" "}
              {manifestData?.config?.dateFormat
                ? dayjs
                    .unix(blogItem?.date?.sec)
                    .format(`${manifestData?.config?.dateFormat}`)
                    .toString()
                : dayjs
                    .unix(blogItem?.date?.sec)
                    .format("ddd, MMM DD, YYYY, hh:mm A z")
                    .toString()}
            </strong>
          </span>
        ) : null}
        <FeatureSection
          dangerouslySetInnerHTML={{
            __html: blogItem.content,
          }}
        />
      </Card>

      {showImage !== "none" && showImage !== "top" ? (
        <div
          style={{
            maxWidth: "83%",
            paddingBottom: "30px",
          }}
        >
          <ImageGallery
            items={images}
            ref={galleryRef}
            showPlayButton={false}
            showFullscreenButton={images.length > 0 ? true : false}
            lazyLoad={true}
            onClick={() => handleFullscreen()}
            onScreenChange={(isFullScreen) => handleScreenChange(isFullScreen)}
            showNav={false}
            showBullets={images.length > 1 ? true : false}
          />
        </div>
      ) : null}
    </div>
  );
}
